import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminMunicipalities_idParse_usage = z.any()
export type TagsGetAdminMunicipalities_idParse_usage = z.infer<typeof tagsGetAdminMunicipalities_idParse_usage>

export const paramsGetAdminMunicipalities_idParse_usage = z.object({ "id": z.string() })
export type ParamsGetAdminMunicipalities_idParse_usage = z.infer<typeof paramsGetAdminMunicipalities_idParse_usage>

export const responseGetAdminMunicipalities_idParse_usage = z.object({ "payload": z.object({ "limit": z.number(), "usedThisYear": z.number(), "remaining": z.number(), "invoices": z.number(), "consumptions": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminMunicipalities_idParse_usage = z.infer<typeof responseGetAdminMunicipalities_idParse_usage>

interface IGetAdminMunicipalities_idParse_usage extends BaseMethodType {
  tags: TagsGetAdminMunicipalities_idParse_usage,
  params: ParamsGetAdminMunicipalities_idParse_usage,
  response: ResponseGetAdminMunicipalities_idParse_usage
}
export const URL = '/admin/municipalities/:id/parse-usage'
export const validation = {
  get: {
    tags: tagsGetAdminMunicipalities_idParse_usage,
    params: paramsGetAdminMunicipalities_idParse_usage,
    response: responseGetAdminMunicipalities_idParse_usage
  }
}
export interface AdminMunicipalities_idParse_usage extends BaseRouteType {
  get: IGetAdminMunicipalities_idParse_usage
}